module.exports = __webpack_public_path__ + "static/lajasse_purple-d2ca46b3400bf2aadacbdf7e9241eb70.png";